import { forwardRef, useImperativeHandle, useState } from "react";
import { Modal } from "../../../components/modal";
import { CiImport } from "react-icons/ci";
import { Link } from "react-router-dom";
import { MdOutlineArrowRightAlt } from "react-icons/md";

const View = ({ type }, ref) => {
	const [show, setShow] = useState(false);
	const [data, setData] = useState({});

	useImperativeHandle(ref, () => ({
		open(data) {
			setShow(true);
			setData(data);
		},
	}));

	return (
		<Modal size={"md"} show={show} setShow={setShow}>
			{type === "report" ? (
				<div className="flex justify-start flex-col items-start gap-y-2">
					<p
						style={{ wordBreak: "break-word" }}
						className="text-lg font-semibold"
					>
						Reason To Report
					</p>
					<div
						style={{ wordBreak: "break-word" }}
						className="font-normal"
					>
						{data?.reason || "No reason was provided!"}
					</div>
					<p
						style={{ wordBreak: "break-word" }}
						className="text-lg font-semibold"
					>
						{!!data?.answer
							? "Answer Details:"
							: !!data?.question
							? "Question Details:"
							: "Comment Details:"}
					</p>
					<div
						style={{ wordBreak: "break-word" }}
						className="font-normal"
					>
						<div
							dangerouslySetInnerHTML={{
								__html: !!data?.answer
									? data?.answer
									: !!data?.question
									? data?.question
									: data?.comment,
							}}
						/>
					</div>
					<Link
						to={`/users/question-details/${data?.question_id}`}
						className="flex text-orange-600 justify-start items-center gap-2 group"
					>
						View {!!data?.answer
							? "Answer"
							: !!data?.question
							? "Question"
							: "Comment"}
						<MdOutlineArrowRightAlt className="group group-hover:translate-x-3 duration-200" />
					</Link>
				</div>
			) : (
				<div className="flex justify-start flex-col items-start gap-y-2">
					<p
						style={{ wordBreak: "break-word" }}
						className="text-lg font-semibold"
					>
						{data?.user_name}
					</p>

					<p
						style={{ wordBreak: "break-word" }}
						className="font-normal"
					>
						Email: {data?.user_email}
					</p>
					{!(
						type === "rfq" ||
						type === "request-join-research" ||
						type === "expert-hiring-form"
					) && (
						<p
							style={{ wordBreak: "break-word" }}
							className="font-normal"
						>
							Ticket Type: {data?.ticket_type}
						</p>
					)}
					{type !== "expert-hiring-form" && (
						<p
							style={{ wordBreak: "break-word" }}
							className="font-normal"
						>
							{type === "rfq" || type === "request-join-research"
								? "Company"
								: "Reason"}
							: {data?.reason}
						</p>
					)}
					<p
						style={{ wordBreak: "break-word" }}
						className="text-lg font-semibold"
					>
						{type === "rfq" ||
						type === "request-join-research" ||
						type === "expert-hiring-form"
							? "Details"
							: "Description"}
						:
					</p>
					{type === "request-join-research" ? (
						<div className="flex justify-start items-start flex-col gap-3">
							<div className="flex justify-start items-start gap-x-3 md:flex-row flex-col">
								<div>Phone Number:</div>
								<div style={{ wordBreak: "break-word" }}>
									{data?.others?.[0]?.phoneNumber}
								</div>
							</div>
							<div className="flex justify-start items-start gap-x-3 md:flex-row flex-col">
								<div>Qualification:</div>
								<div style={{ wordBreak: "break-word" }}>
									{data?.others?.[0]?.degree}
								</div>
							</div>
							<div className="flex justify-start items-start gap-x-3 md:flex-row flex-col">
								<div>Current Position :</div>
								<div style={{ wordBreak: "break-word" }}>
									{data?.description}
								</div>
							</div>
							<div className="flex justify-start items-start gap-x-3 md:flex-row flex-col">
								<div>Relevant Experience:</div>
								<div style={{ wordBreak: "break-word" }}>
									{data?.others?.[0]?.prevExperience}
								</div>
							</div>
							<a
								href={data?.others?.[0]?.file}
								target="_blank"
								download
								rel="noreferrer"
								className={`shrink-0 py-2 transition-all duration-200 ease-in-out text-sm gap-x-3 px-3 text-white bg-orange-600 rounded-full flex justify-center hover:opacity-70 hover:scale-105`}
							>
								<CiImport size={20} />
								Download CV
							</a>
						</div>
					) : type === "expert-hiring-form" ? (
						<div className="flex justify-start items-start flex-col gap-3">
							<div className="flex justify-start items-start gap-x-3 md:flex-row flex-col">
								<div>Expertise:</div>
								<div style={{ wordBreak: "break-word" }}>
									{data?.description}
								</div>
							</div>
							<div className="flex justify-start items-start gap-x-3 md:flex-row flex-col">
								<div>Additional Comments:</div>
								<div style={{ wordBreak: "break-word" }}>{data?.reason}</div>
							</div>
							<div className="flex justify-start items-start gap-x-3 md:flex-row flex-col">
								<div>Date Range:</div>
								<div>
									{data?.others?.[0]?.dateRange?.[0]?.slice(0, 10)} -{" "}
									{data?.others?.[0]?.dateRange?.[1]?.slice(0, 10)}
								</div>
							</div>
							<div className="flex justify-start items-start gap-x-3 md:flex-row flex-col">
								<div>Hourly Rate:</div>
								<div style={{ wordBreak: "break-word" }}>
									{data?.others?.[0]?.hourlyRate}
								</div>
							</div>
							<div className="flex justify-start items-start gap-x-3 md:flex-row flex-col">
								<div>Web Portofolio:</div>
								<div style={{ wordBreak: "break-word" }}>
									{data?.others?.[0]?.portfolioWeb || "Not Specified!"}
								</div>
							</div>
							<div className="flex justify-start items-start gap-x-3 md:flex-row flex-col">
								<div>Previous Experience:</div>
								<div style={{ wordBreak: "break-word" }}>
									{data?.others?.[0]?.prevExperience}
								</div>
							</div>
							<div className="flex justify-start items-start gap-x-3 md:flex-row flex-col">
								<div>Phone Number:</div>
								<div style={{ wordBreak: "break-word" }}>
									{data?.others?.[0]?.phoneNumber}
								</div>
							</div>
							<a
								href={data?.others?.[0]?.file}
								target="_blank"
								download
								rel="noreferrer"
								className={`shrink-0 py-2 transition-all duration-200 ease-in-out text-sm gap-x-3 px-3 text-white bg-orange-600 rounded-full flex justify-center hover:opacity-70 hover:scale-105`}
							>
								<CiImport size={20} />
								Download CV
							</a>
						</div>
					) : (
						<div
							style={{ wordBreak: "break-word" }}
							className="font-normal"
						>
							{data?.description ||
								(type === "rfq"
									? "No Purpose/Requirement Details provided!"
									: "No description provided!")}
						</div>
					)}
				</div>
			)}
		</Modal>
	);
};

export default forwardRef(View);
